import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from 'lib/utils';
import { ConfigureNavIcon } from './configure-nav-icon';
import { getVisibleConfigureNavItems } from 'constant/configure-nav';
import { isPathActive } from 'utils/is-path-active';
import { useCommonStore } from 'state/store/common/useCommonStore';
import { useSidebar } from 'components/ui/sidebar';
import { useTheme } from 'components/core/theme-provider';

/**
 * Skills, Knowledge base and Tools links pinned under the chat list.
 * Shared by the desktop chats panel and the phone/tablet overlay so both look the same.
 */
export function SidebarConfigurePanel() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { theme } = useTheme();
  const { isSidebarOverlay, setOpenMobile } = useSidebar();
  const userRoles = useCommonStore((state) => state.user?.roles ?? []);
  const navItems = getVisibleConfigureNavItems(userRoles);
  const textColor = theme === 'dark' ? 'text-grey-50' : 'text-grey-900';

  return (
    <nav
      data-buddy-tour-target="quick-actions"
      className="shrink-0 border-t border-grey-100 pb-6 pl-5 pr-3 pt-4 dark:border-sidebar-border"
    >
      {navItems.map((item) => {
        const active = isPathActive(pathname, item.path);

        return (
          <Link
            key={item.id}
            to={item.path}
            onClick={() => {
              if (isSidebarOverlay) {
                setOpenMobile(false);
              }
            }}
            aria-current={active ? 'page' : undefined}
            className={cn(
              'flex h-10 w-full items-center gap-3 rounded-nav px-2 transition-colors hover:bg-grey-100 dark:hover:bg-sidebar-pill-dark',
              textColor,
              active && 'bg-grey-100 dark:bg-sidebar-pill-dark'
            )}
          >
            <span
              data-testid={item.id === 'skills' ? 'sidebar-skills-icon' : undefined}
              className="flex size-5 shrink-0 items-center justify-center"
            >
              <ConfigureNavIcon icon={item.icon} size={20} strokeWidth={1.5} />
            </span>
            <span className="truncate font-sans text-sm font-normal leading-heading">{t(item.labelKey)}</span>
          </Link>
        );
      })}
    </nav>
  );
}
